import { Icon } from "@nju/icons";
import { Separator, Text } from "@nju/ui";

interface IOrderParametersProps {
  downloadSpeed: string;
  uploadSpeed: string;
  modemName: string | undefined;
}

export function OrderParameters({
  downloadSpeed,
  uploadSpeed,
  modemName,
}: IOrderParametersProps) {
  return (
    <div className="flex">
      <div className="w-full grid gap-4 grid-cols-1 from-tablet:grid-cols-2 from-tablet:grid-rows-1 from-tablet:gap-12">
        <div className="items-center">
          <div className="flex items-center flex-row">
            <Icon
              className="w-5 h-5 mr-3 from-tablet:w-6 from-tablet:h-6"
              name="tachometer-alt-fastest"
              tone="accent"
            />
            <Text
              size={{
                "@onlyMobile": "m",
                "@fromTablet": "xl",
              }}
              weight="bold"
            >
              Twoja prędkość
            </Text>
          </div>
          <Separator size="s" />
          <div className="flex justify-between">
            <Text
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "l",
              }}
            >
              prędkość pobierania:
            </Text>{" "}
            <Text
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "l",
              }}
              weight="bold"
            >
              do {downloadSpeed}
            </Text>
          </div>
          <Separator size="xxs" tone="invisible" />
          <div className="flex justify-between">
            <Text
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "l",
              }}
            >
              prędkość wysyłania:
            </Text>{" "}
            <Text
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "l",
              }}
              weight="bold"
            >
              do {uploadSpeed}
            </Text>
          </div>
        </div>
        {modemName && (
          <div className="items-center">
            <div className="flex flex-row items-center">
              <Icon
                className="w-5 h-5 mr-3 from-tablet:w-6 from-tablet:h-6"
                name="router"
                tone="accent"
              />
              <Text
                size={{
                  "@onlyMobile": "m",
                  "@fromTablet": "xl",
                }}
                weight="bold"
              >
                dane urządzenia
              </Text>
            </div>
            <Separator size="s" />
            <div className="flex">
              <Text
                size={{
                  "@onlyMobile": "s",
                  "@fromTablet": "l",
                }}
              >
                modem:
              </Text>
            </div>
            <Separator size="xxs" tone="invisible" />
            <div className="flex">
              <Text
                size={{
                  "@onlyMobile": "s",
                  "@fromTablet": "l",
                }}
                weight="bold"
              >
                {modemName}
              </Text>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
